import SmartSalesLogo from 'oldAssets/images/icons/smart-sales.svg';
import Benefit1 from 'oldAssets/images/static_pages/smart_sales/benefit-1.webp';
import Benefit2 from 'oldAssets/images/static_pages/smart_sales/benefit-2.webp';
import Benefit3 from 'oldAssets/images/static_pages/smart_sales/benefit-3.webp';
import HouseEN from 'oldAssets/images/static_pages/smart_sales/house_en.webp';
import HouseDE from 'oldAssets/images/static_pages/smart_sales/house_de.webp';
import CustomerPhoto from 'oldAssets/images/static_pages/smart_sales/canan_photo.webp';
import Step1 from 'oldAssets/images/static_pages/smart_sales/step-1.webp';
import Step4 from 'oldAssets/images/static_pages/smart_sales/step-4.webp';
import Step5 from 'oldAssets/images/static_pages/smart_sales/step-5.svg';
import Icon1 from 'oldAssets/images/static_pages/smart_sales/icon-1.svg';
import Icon2 from 'oldAssets/images/static_pages/smart_sales/icon-2.svg';
import Icon3 from 'oldAssets/images/static_pages/smart_sales/icon-3.svg'; 
import { importAllImagesFromFolder } from 'lib/utils/imagesUtils';

const logos = [Benefit1, Benefit2, Benefit3];
const firstStepsIcons = [Icon1, Icon2, Icon3];

const overviewPhotoContext = require.context(
  'oldAssets/images/static_pages/smart_sales/ss_photos',
  false, /ss-overview-photo-\d\d.webp$/);
const overviewImages = importAllImagesFromFolder(overviewPhotoContext);

const house = (locale) => locale == 'en' ? HouseEN : HouseDE;
const Steps = [Step1, Step4, Step5];


export {
  SmartSalesLogo, logos, firstStepsIcons, overviewImages,
  house, CustomerPhoto, Steps
}